import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { IEditInfo, IReceipt } from '@shared/models';
import * as fromRootStore from '@store/index';

import { ReceiptModalComponent } from './components/receipt-modal/receipt-modal.component';
import { ReceiptSectionComponent } from './components/receipt-section/receipt-section.component';

@Component({
  selector: 'app-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.scss'],
  standalone: true,
  imports: [ReceiptSectionComponent, ReceiptModalComponent],
})
export class ReceiptComponent {
  @ViewChild('receiptModal') receiptModal;

  @Input()
  public set receiptArray(array: IReceipt[]) {
    this._receiptArray = array.filter((x) => x != null);
  }

  @Output()
  noRoutingEditing: EventEmitter<IReceipt | IEditInfo> = new EventEmitter<IReceipt | IEditInfo>();

  _receiptArray: IReceipt[];

  constructor(protected globalStore: Store<fromRootStore.State>) {}

  userEdit(editInfo: IEditInfo) {
    if (editInfo.editable && editInfo.editRoute) {
      this.globalStore.dispatch(fromRootStore.Go({ path: [editInfo.editRoute] }));
    }
  }

  handleNoRoutingEditing(event: IReceipt | IEditInfo) {
    this.noRoutingEditing.emit(event);
  }
}
